import React, { Fragment, useState } from 'react';
import { 
    Modal, ModalHeader, ModalBody, ModalFooter, Button, Form, FormGroup, Label, 
    Input, Row, Col, FormFeedback, InputGroup, InputGroupAddon, InputGroupText 
} from 'reactstrap';
import { SET_ADMIN_FORM_PROFILE_PICTURE } from '../../../redux/actions/ActionTypes';
import { useFormik} from 'formik';
import * as Yup from 'yup';
import { ONLY_STRING, TEN_DIGIT_PHONE_NUMBER_REGEX } from '../../../utils/constants/ValidationRegexs';
import { authHeader, authfileHeader } from '../../../utils/functions/CoreFunctions';
import { ADMIN_USERS_CREATE_URL, ADMIN_USERS_UPDATE_URL, FILE_UPLOAD_URL } from '../../../utils/APIEndpoints';
import API from '../../../redux/actions/API';
import Swal from 'sweetalert2';
import { getAlertToast, getCurrentUserId, SingleStringFirstLetterCaps } from '../../../utils/functions/CustomFunctions';
import defaultAvatar from '../../../assets/images/defaultImages/defaultAvatar.png';
import CustomLoader from '../../common/CustomLoader';
import { useDispatch, useSelector } from 'react-redux';
//Validation Schema
const validationSchema = Yup.object({
    firstName : Yup.string().trim().required('First name is required').matches(ONLY_STRING, 'Only letters allowed'),
    lastName : Yup.string().trim().required('Last name is required').matches(ONLY_STRING, 'Only letters allowed'),
    email : Yup.string().trim().required('Email is required').email('Enter valid email'),
    phoneNumber : Yup.string().trim().required('Phone number is required').matches(TEN_DIGIT_PHONE_NUMBER_REGEX,'Enter valid phone number'),
    address : Yup.string().trim().required('Address is required'),
});

function AdminCRUDDialog(props){
    const {
        submitCallback,
        userData,
        toggle,
        modal : dialogFlag = false,
        isAdd : isAddForm = false
    } = props;
    const AdminCRUDForm = useSelector(state => state.AdminCRUDForm);
    const dispatch = useDispatch();
    const {
        profileImage
    } = AdminCRUDForm;

    const[btnLoading, setBtnLoading] = useState(false);

    const handleUpload = async e => {
     e.preventDefault();
     const selectedFile = e.target.files[0];
     if(selectedFile)
     {
            const formData = new FormData();
            formData.append('file', selectedFile);     
            const options = {
                method : 'POST',
                url : FILE_UPLOAD_URL,
                headers: authfileHeader(),
                data: formData
            };
            try{
                Swal.fire(getAlertToast('success',  'Please wait...' ));
                var apiResponse = await API(options);
                const {status, filepath} = apiResponse.data;
                if(status === 'Success')
                {  
                    dispatch({
                        type : SET_ADMIN_FORM_PROFILE_PICTURE,
                        payload : filepath
                    });
            }
            }catch(error){
                if (error.response) {
                Swal.fire(getAlertToast('error', 'File upload failed, please try again!' ));
                }
            }
        }
   }; 

    //On Submit
    const saveFormValues = async (values) => {
         values.createdBy = getCurrentUserId();
         values.profileImage = profileImage;
         delete values.isAddForm;
         delete values.dialogFlag;
         values.hyperlink = window.location.origin+'/signin'; //Route Link For Login From Email
         const options = {
           method : isAddForm ? 'POST' : 'PUT',
           url : isAddForm? ADMIN_USERS_CREATE_URL : ADMIN_USERS_UPDATE_URL,
           headers: authHeader(),
           data : values
         };
        try{
            setBtnLoading(true);
            let response = await API(options);
            const {status,message} = response.data;
            if(status === 'Error'){
                Swal.fire(getAlertToast('error', message ));
            }
            else{  
                Swal.fire(getAlertToast('success', isAddForm ? 'New admin is created and password is sent via email' : 'Admin details updated successfully' ));
                resetForm({
                    firstName: '',
                    lastName: '',
                    email: '',
                    phoneNumber: '',
                    address: '',
                });  
                submitCallback();
            }            
        }catch(error){
            if (error.response) {
                let { data } = error.response;
                Swal.fire(getAlertToast('error', data.message ));
            }
        }finally{
            setBtnLoading(false);
        }
    } 
    //Formik
    const {handleSubmit,handleChange,values,errors,touched,setFieldTouched,setFieldValue, resetForm} = useFormik({        
        initialValues : {
            ...userData
        },
        enableReinitialize : true,
        validationSchema,
        onSubmit:(values) => saveFormValues(values)        
    }); 

    const dialogToggle = () => {
        resetForm({
            firstName: '',
            lastName: '',
            email: '',
            phoneNumber: '',
            address: '',
        });
        toggle();
    }
    const closeBtn = <a className='close' onClick={dialogToggle}>&times;</a>;
    return(
        <Fragment>
            <Modal isOpen={dialogFlag} toggle={dialogToggle} style={{maxWidth:'800px'}} backdrop="static">
                <Form form='true' onSubmit={handleSubmit}>
                    <ModalHeader toggle={dialogToggle} close={closeBtn}>{isAddForm ? 'New ' : 'Update '} Admin</ModalHeader>
                    <ModalBody>
                        
                        <div className='imgUpload'>
                        <img className='uploadImg' src={profileImage || defaultAvatar} widht={100} height={100}/>
                        <label style={{marginBottom: '0'}} className='btn-bs-file btn btn-lg btn-danger'>  
                        <i className='fas fa-camera'></i>            
                        <Input type='file' accept='.jpg,.jpeg,.png' onChange={handleUpload} />
                        </label>
                        </div>
     
     
                        <Row>
                            <Col md={6}>
                                <FormGroup>
                                <Label for='firstName'>First Name</Label>
                                    <Input type='text' name='firstName' id='firstName' placeholder='First Name'
                                    invalid={(errors.firstName && touched.firstName) ? true : false} 
                                    onChange={({target : { value}}) => {
                                        setFieldTouched('firstName',true);                                        
                                        setFieldValue('firstName',SingleStringFirstLetterCaps(value));
                                    }} 
                                    value={values.firstName}/>
                                    <FormFeedback>{(errors.firstName && touched.firstName) ? errors.firstName : ''}</FormFeedback>
                                </FormGroup>
                            </Col>
                            <Col md={6}>
                                <FormGroup>
                                <Label for='lastName'>Last Name</Label>
                                    <Input type='text' name='lastName' id='lastName' placeholder='Last Name'
                                    invalid={(errors.lastName && touched.lastName) ? true : false} 
                                    onChange={({target : { value}}) => {
                                        setFieldTouched('lastName',true);
                                        setFieldValue('lastName',SingleStringFirstLetterCaps(value));
                                    }}  
                                    value={values.lastName}/>
                                    <FormFeedback>{(errors.lastName && touched.lastName) ? errors.lastName : ''}</FormFeedback>
                                </FormGroup>
                            </Col>
                            <Col md={6}>
                                <FormGroup>
                                <Label for='email'>Email</Label>
                                    <Input type='email' name='email' id='email' placeholder='Email'
                                    invalid={(errors.email && touched.email) ? true : false} onChange={(event) => {
                                        setFieldTouched('email',true);
                                        handleChange(event);
                                    }}  value={values.email} disabled={isAddForm?false: true}/>
                                    <FormFeedback>{(errors.email && touched.email) ? errors.email : ''}</FormFeedback>
                                </FormGroup>
                            </Col>
                            <Col md={6}>
                                <FormGroup>
                                <Label for='phoneNumber'>Phone Number</Label>
                                    <InputGroup>
                                        <InputGroupAddon addonType='prepend'>
                                            <InputGroupText>+1</InputGroupText>
                                        </InputGroupAddon>
                                        <Input type='text' name='phoneNumber' id='phoneNumber' placeholder='Phone Number'
                                        invalid={(errors.phoneNumber && touched.phoneNumber) ? true : false} onChange={(event) => {
                                            setFieldTouched('phoneNumber',true);
                                            handleChange(event);
                                        }}  value={values.phoneNumber}/>
                                        <FormFeedback>{(errors.phoneNumber && touched.phoneNumber)? errors.phoneNumber : ''}</FormFeedback>
                                    </InputGroup>
                                </FormGroup>
                            </Col>
                            <Col md={12}>
                                <FormGroup>
                                <Label for='address'>Address</Label>
                                    <Input type='textarea' name='address' id='address' placeholder='Address'
                                    invalid={(errors.address && touched.address) ? true : false} 
                                    onChange={({target:{value}}) => {
                                        setFieldTouched('address',true);
                                        setFieldValue('address',SingleStringFirstLetterCaps(value));
                                    }}  value={values.address}/>
                                    <FormFeedback>{(errors.address && touched.address) ? errors.address : ''}</FormFeedback>
                                </FormGroup>
                            </Col>
                        </Row>
                    </ModalBody>
                    <ModalFooter>
                    <Button color='primary' type='submit' >{btnLoading && <CustomLoader loading={btnLoading}/>}{' '}{isAddForm ? 'Create' : 'Update'}</Button>{' '}
                        <Button color='secondary' onClick={dialogToggle}>Cancel</Button>
                    </ModalFooter>
                </Form>
            </Modal>
        </Fragment>
    );
}
export default AdminCRUDDialog;